import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Capacitor } from '@capacitor/core';

const COOKIE_CONSENT_KEY = 'tuvisa_cookie_info_accepted';

/**
 * Banner informativo de cookies (LSSI-CE España)
 * 
 * Solo cookies técnicas (auth_token) → exentas de consentimiento previo.
 * El banner es INFORMATIVO, no bloquea nada.
 * No se muestra en la APK de Android (Capacitor).
 */
const CookieBanner = () => {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        // No mostrar en APK nativa
        if (Capacitor.isNativePlatform()) return;

        // Verificar si ya aceptó
        const accepted = localStorage.getItem(COOKIE_CONSENT_KEY);
        if (!accepted) {
            // Pequeño delay para no molestar al instante
            const timer = setTimeout(() => setVisible(true), 1000);
            return () => clearTimeout(timer);
        }
    }, []);

    const handleAccept = () => {
        localStorage.setItem(COOKIE_CONSENT_KEY, 'true');
        setVisible(false);
    };

    if (!visible) return null;

    return (
        <div
            id="cookie-banner"
            style={{
                position: 'fixed',
                bottom: 0,
                left: 0,
                right: 0,
                zIndex: 9998,
                padding: '1rem 1.5rem',
                background: 'rgba(15, 23, 42, 0.95)',
                backdropFilter: 'blur(16px)',
                borderTop: '1px solid rgba(56, 189, 248, 0.2)',
                boxShadow: '0 -4px 20px rgba(0, 0, 0, 0.4)',
                animation: 'slideUp 0.4s ease-out'
            }}
        >
            <style>{`
                @keyframes slideUp {
                    from { transform: translateY(100%); opacity: 0; }
                    to { transform: translateY(0); opacity: 1; }
                }
            `}</style>

            <div style={{
                maxWidth: '960px',
                margin: '0 auto',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                gap: '1rem',
                flexWrap: 'wrap'
            }}>
                <div style={{ flex: 1, minWidth: '250px' }}>
                    <p style={{
                        margin: 0,
                        fontSize: '0.9rem',
                        color: '#cbd5e1',
                        lineHeight: 1.5
                    }}>
                        🍪 Esta web utiliza <strong>cookies técnicas</strong> necesarias para la autenticación.
                        No usamos cookies de análisis ni publicidad.{' '}
                        <Link to="/cookies" style={{
                            color: '#38bdf8',
                            textDecoration: 'underline',
                            textUnderlineOffset: '2px'
                        }}>
                            Más información
                        </Link>
                    </p>
                </div>

                <button
                    onClick={handleAccept}
                    id="cookie-accept-btn"
                    style={{
                        padding: '0.6rem 1.5rem',
                        borderRadius: '0.75rem',
                        border: 'none',
                        background: 'linear-gradient(135deg, #0ea5e9 0%, #0284c7 100%)',
                        color: 'white',
                        fontWeight: 600,
                        fontSize: '0.9rem',
                        cursor: 'pointer',
                        whiteSpace: 'nowrap',
                        transition: 'transform 0.15s, box-shadow 0.15s',
                        boxShadow: '0 2px 8px rgba(14, 165, 233, 0.3)'
                    }}
                    onMouseEnter={e => {
                        e.target.style.transform = 'scale(1.03)';
                        e.target.style.boxShadow = '0 4px 16px rgba(14, 165, 233, 0.4)';
                    }}
                    onMouseLeave={e => {
                        e.target.style.transform = 'scale(1)';
                        e.target.style.boxShadow = '0 2px 8px rgba(14, 165, 233, 0.3)';
                    }}
                >
                    Entendido
                </button>
            </div>
        </div>
    );
};

export default CookieBanner;
